import { render, staticRenderFns } from "./NotificationSender.vue?vue&type=template&id=086c0a12"
import script from "./NotificationSender.vue?vue&type=script&lang=js"
export * from "./NotificationSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports